'use client';

import { create } from 'zustand';
import type { Business } from '@/types/business';

export const SELECTED_BUSINESS_KEY = 'bizpos_selected_business_id';

interface MerchantState {
  business: Business | null;
  businesses: Business[];
  selectedBusinessId: number | null;

  setBusiness: (b: Business) => void;
  setBusinesses: (list: Business[]) => void;
  selectBusiness: (id: number) => void;
  clearBusiness: () => void;
}

export const useMerchantStore = create<MerchantState>((set) => ({
  business: null,
  businesses: [],
  selectedBusinessId: (() => {
    if (typeof window === 'undefined') return null;
    const saved = localStorage.getItem(SELECTED_BUSINESS_KEY);
    return saved ? Number(saved) : null;
  })(),

  setBusiness: (business) => set({ business }),

  setBusinesses: (businesses) => set({ businesses }),

  selectBusiness: (id) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(SELECTED_BUSINESS_KEY, String(id));
    }
    set({ selectedBusinessId: id });
  },

  clearBusiness: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(SELECTED_BUSINESS_KEY);
    }
    set({ business: null, businesses: [], selectedBusinessId: null });
  },
}));
